'use strict';

class RcmFatLoader {
    constructor(fat) {
        this.fat = fat;

        // DOM
        this.loader = $('#fatv2-loader');
    }

    // Show page loader
    show() {
        this.loader.stop(true, false).fadeIn(250, function () {
            $(this).css('display', 'flex');
        });

        // Console debug
        if (console && console.log) {
            console.log('RcmFatLoader.show');
        }
    }

    // Hide page loader
    hide() {
        this.loader.stop(true, false).fadeOut(250);

        // Console debug
        if (console && console.log) {
            console.log('RcmFatLoader.hide');
        }
    }
}
